import React, { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { setActiveMeetingMemberListActiveStatus } from 'flow/actions/meeting-actions';
import {
    selectActiveMeetingMemberListActiveStatus,
    selectViewerIsInternal,
} from 'flow/selectors/meeting-selectors';
import useWaitingParticipants from 'flow/components/meeting/MeetingParticipantsList/useWaitingParticipants';
import { getFooterButtonHiddenClass } from 'flow/utils/meeting-footer-utils';
import MeetingButton from 'flow/components/meeting/MeetingButton';

export const ButtonToggleMembersList = () => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();

    const membersListActive = useAppSelector(
        selectActiveMeetingMemberListActiveStatus,
    );

    // Someone at the door changes what this button is for: it stops being "see
    // who is here" and becomes the way to a decision, so it says so (VID-76).
    // Gated on being internal like everything else about the queue — a guest is
    // not shown it, so their button must not hint at it either.
    const viewerIsInternal = useAppSelector(selectViewerIsInternal);
    const waitingParticipants = useWaitingParticipants();
    const someoneIsWaiting = viewerIsInternal && waitingParticipants.length > 0;

    const onClick = useCallback(() => {
        dispatch(setActiveMeetingMemberListActiveStatus(!membersListActive));
    }, [dispatch, membersListActive]);

    return (
        <div
            className={twMerge(
                'flex items-center select-none',
                getFooterButtonHiddenClass(),
            )}
        >
            <MeetingButton
                iconType={someoneIsWaiting ? 'adminPanelSettings' : 'group'}
                active={membersListActive}
                highlighted={someoneIsWaiting}
                subtleActive={true}
                invertOnHover={true}
                callback={onClick}
                hoverText={i18next.t(
                    'videoconference.controlpanel.participants',
                )}
                circular={true}
            />
        </div>
    );
};

export default ButtonToggleMembersList;
